"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_design_system_1 = require("@hdh-core/react-design-system");
const prop_types_1 = __importDefault(require("prop-types"));
/**
 * Loading sub-app
 */
const App = ({ loading }) => react_1.default.createElement(react_design_system_1.LoadingSpinner, { visible: loading });
App.propTypes = {
    loading: prop_types_1.default.bool
};
App.defaultProps = {
    loading: false
};
exports.default = App;
